import { useEffect, useState } from 'react';
import axiosInstance from '../api/axiosInstance';

export const EMPTY_HOME_PAGE_CONTENT = {
  hero_title_line1: '',
  hero_title_line2: '',
  hero_description: '',
  hero_button_programs: '',
  hero_button_more: '',

  stat_students: '',
  stat_students_label: '',
  stat_experience: '',
  stat_experience_label: '',
  stat_prizes: '',
  stat_prizes_label: '',
  stat_result: '',
  stat_result_label: '',

  about_title: '',
  about_subtitle: '',
  about_description_1: '',
  about_description_2: '',
  about_stat_1_number: '',
  about_stat_1_label: '',
  about_stat_2_number: '',
  about_stat_2_label: '',
  about_stat_3_number: '',
  about_stat_3_label: '',
  about_stat_4_number: '',
  about_stat_4_label: '',

  feature_1_title: '',
  feature_1_desc: '',
  feature_2_title: '',
  feature_2_desc: '',
  feature_3_title: '',
  feature_3_desc: '',
  feature_4_title: '',
  feature_4_desc: '',

  coach_name: '',
  coach_description: '',
  coach_achievement_1_title: '',
  coach_achievement_1_desc: '',
  coach_achievement_2_title: '',
  coach_achievement_2_desc: '',
  coach_achievement_3_title: '',
  coach_achievement_3_desc: '',
  coach_qualifications_title: '',
  coach_qualification_1: '',
  coach_qualification_2: '',
  coach_qualification_3: '',
  coach_qualification_4: '',

  programs_section_title: '',
  programs_section_description: '',
  articles_section_title: '',
  articles_section_description: '',
  trainers_page_title: '',
  trainers_page_description: '',

  power_training_badge: '',
  power_training_title: '',
  power_training_description: '',
  power_training_for_whom_title: '',
  power_training_for_whom_desc: '',
  power_training_format_title: '',
  power_training_format_desc: '',
  power_training_coach_title: '',
  power_training_coach_desc: '',
  power_training_approach_title: '',
  power_training_approach_desc: '',
  power_training_footer_text: '',

  power_training_modal_title: '',
  power_training_modal_subtitle: '',
  power_training_modal_about_title: '',
  power_training_modal_about_description: '',
  power_training_modal_features_title: '',
  power_training_modal_benefits_title: '',
  power_training_modal_benefit_1: '',
  power_training_modal_benefit_2: '',
  power_training_modal_benefit_3: '',
  power_training_modal_benefit_4: '',

  power_training_page_what_title: '',
  power_training_page_what_description: '',
  power_training_page_point_1: '',
  power_training_page_point_2: '',
  power_training_page_point_3: '',
  power_training_page_point_4: '',
  power_training_page_format_title: '',

  footer_team_name: '',
  footer_team_description: '',
};

let cachedHomePageContent = null;

const mergeWithDefaults = (content) => ({
  ...EMPTY_HOME_PAGE_CONTENT,
  ...(content || {}),
});

export default function useHomePageContent() {
  const [content, setContent] = useState(mergeWithDefaults(cachedHomePageContent));
  const [isLoading, setIsLoading] = useState(!cachedHomePageContent);

  useEffect(() => {
    let isMounted = true;

    const load = async () => {
      if (cachedHomePageContent) {
        setContent(mergeWithDefaults(cachedHomePageContent));
        setIsLoading(false);
        return;
      }

      try {
        const response = await axiosInstance.get('site-content/homepage/');
        cachedHomePageContent = response?.data || {};
        if (isMounted) {
          setContent(mergeWithDefaults(cachedHomePageContent));
        }
      } catch (error) {
        if (isMounted) {
          setContent(mergeWithDefaults(null));
        }
      } finally {
        if (isMounted) {
          setIsLoading(false);
        }
      }
    };

    load();

    return () => {
      isMounted = false;
    };
  }, []);

  return { content, isLoading };
}
